import Mustache from 'mustache';

import { AmountInterval } from '@cashier/cashier-model';

import { prepareFormula } from './prepareFormula';

const getTemplateCondition = (bonusConfiguration: AmountInterval): string => {
  const conditionsMap: { [key: string]: { [key: string]: string } } = {
    coins: {
      measurementCondition: '{{formula}} {{attributes.measurement}}',
      rewardFormatCondition: '{{reward.from}} {{attributes.measurement}}',
      volumeMeasurementCondition:
        '{{attributes.measurement}}{{attributes.volume}}',
    },
    currency: {
      measurementCondition: '{{attributes.measurement}}{{formula}}',
      rewardFormatCondition: '{{attributes.measurement}}{{reward.from}}',
      volumeMeasurementCondition:
        '{{attributes.measurement}}{{attributes.volume}}',
    },
    fs: {
      measurementCondition: '{{attributes.measurement}}{{formula}}',
      rewardFormatCondition: '{{attributes.measurement}}{{reward.from}}',
      volumeMeasurementCondition:
        '{{attributes.volume}}{{attributes.measurement}}',
    },
  };
  const result = conditionsMap[bonusConfiguration.attributes.measurement];

  if (bonusConfiguration.title.params.formula) {
    return result.measurementCondition;
  } else if (bonusConfiguration.reward.from) {
    return result.rewardFormatCondition;
  } else {
    return result.volumeMeasurementCondition;
  }
};
export const generateBonusPayload = (
  amount: string,
  currency: string,
  bonusConfiguration: AmountInterval,
): string => {
  const formula = prepareFormula(bonusConfiguration, amount, null);

  return Mustache.render(getTemplateCondition(bonusConfiguration), {
    ...bonusConfiguration,
    formula,
    amount: amount || 0,
    currency: 'currency',
  }).replaceAll('currency', `${currency}`);
};
